import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/user.service";
import * as i2 from "@angular/router";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "@ngx-translate/core";
function LoginComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.errorMessage);
  }
}
const _c0 = function (a0) {
  return {
    isInvalid: a0
  };
};
export class LoginComponent {
  constructor(userService, router) {
    this.userService = userService;
    this.router = router;
    this.isBusy = false;
    userService.isAuthenticatedSubject.next(false);
  }
  ngOnInit() {
    localStorage.clear();
  }
  signIn() {
    this.isBusy = true;
    this.errorMessage = null;
    const returnUrl = this.router.routerState.snapshot.root.queryParams.returnUrl ?? '/';
    this.userService.login(this.username, this.password).then(value => {
      this.isBusy = false;
      this.router.navigate([returnUrl]);
    }).catch(errorMessage => {
      this.isBusy = false;
      this.errorMessage = errorMessage;
    });
  }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) {
  return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.Router));
};
LoginComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: LoginComponent,
  selectors: [["ng-component"]],
  decls: 14,
  vars: 10,
  consts: [[1, "row", "justify-content-md-center"], [1, "col-sm-auto"], [1, "card"], [1, "card-block"], [1, "form-signin"], ["class", "alert alert-danger", "role", "alert", 3, "textContent", 4, "ngIf"], ["for", "inputEmail", "translate", "", 1, "sr-only"], ["type", "text", "id", "username", "name", "username", "placeholder", "Username", "required", "", "autofocus", "", 1, "form-control", "mb-1", 3, "ngClass", "ngModel", "ngModelChange"], ["for", "inputPassword", "translate", "", 1, "sr-only"], ["type", "password", "id", "password", "name", "password", "placeholder", "Password", "required", "", 1, "form-control", 3, "ngClass", "ngModel", "ngModelChange"], ["type", "submit", "translate", "", 1, "btn", "btn-lg", "btn-primary", "btn-block", "mt-3", 3, "disabled", "click"], ["role", "alert", 1, "alert", "alert-danger", 3, "textContent"]],
  template: function LoginComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "form", 4);
      i0.ɵɵtemplate(5, LoginComponent_div_5_Template, 1, 1, "div", 5);
      i0.ɵɵelementStart(6, "label", 6);
      i0.ɵɵtext(7, "Username");
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(8, "input", 7);
      i0.ɵɵlistener("ngModelChange", function LoginComponent_Template_input_ngModelChange_8_listener($event) {
        return ctx.username = $event;
      });
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(9, "label", 8);
      i0.ɵɵtext(10, "Password");
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(11, "input", 9);
      i0.ɵɵlistener("ngModelChange", function LoginComponent_Template_input_ngModelChange_11_listener($event) {
        return ctx.password = $event;
      });
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(12, "button", 10);
      i0.ɵɵlistener("click", function LoginComponent_Template_button_click_12_listener() {
        return ctx.signIn();
      });
      i0.ɵɵtext(13, " Sign In ");
      i0.ɵɵelementEnd()()()()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(5);
      i0.ɵɵproperty("ngIf", ctx.errorMessage);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, !!ctx.errorMessage))("ngModel", ctx.username);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, !!ctx.errorMessage))("ngModel", ctx.password);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("disabled", ctx.isBusy || !ctx.username || !ctx.password);
    }
  },
  dependencies: [i3.NgClass, i3.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.NgModel, i4.NgForm, i5.TranslateDirective],
  styles: [".card[_ngcontent-%COMP%] {\n  margin-top: 50px;\n}\n\n.card-img-top[_ngcontent-%COMP%] {\n  margin: 0 auto;\n  max-width: 100%;\n  margin-top: 20px;\n}\n\n.form-signin[_ngcontent-%COMP%] {\n  width: 380px;\n  padding: 15px;\n  margin: 0 auto;\n}\n\n.form-signin[_ngcontent-%COMP%]   .form-signin-heading[_ngcontent-%COMP%], .form-signin[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n  margin-bottom: 10px;\n}\n\n.form-signin[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n  font-weight: normal;\n}\n\n.form-signin[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] {\n  position: relative;\n  height: auto;\n  box-sizing: border-box;\n  padding: 10px;\n  font-size: 16px;\n}\n\n.form-signin[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:focus {\n  z-index: 2;\n}\n\n.form-signin[_ngcontent-%COMP%]   input[type=email][_ngcontent-%COMP%] {\n  margin-bottom: -1px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-signin[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%] {\n  margin-bottom: 10px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hcHAvY29tbW9uL2NvbXBvbmVudHMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxnQkFBQTtBQUNKOztBQUVBO0VBQ0ksY0FBQTtFQUNBLGVBQUE7RUFDQSxnQkFBQTtBQUNKOztBQUVBO0VBQ0ksWUFBQTtFQUNBLGFBQUE7RUFDQSxjQUFBO0FBQ0o7O0FBQ0E7O0VBRUksbUJBQUE7QUFFSjs7QUFBQTtFQUNJLG1CQUFBO0FBR0o7O0FBREE7RUFDSSxrQkFBQTtFQUNBLFlBQUE7RUFFQSxzQkFBQTtFQUNBLGFBQUE7RUFDQSxlQUFBO0FBSUo7O0FBRkE7RUFDSSxVQUFBO0FBS0o7O0FBSEE7RUFDSSxtQkFBQTtFQUNBLDZCQUFBO0VBQ0EsNEJBQUE7QUFNSjs7QUFKQTtFQUNJLG1CQUFBO0VBQ0EseUJBQUE7RUFDQSwwQkFBQTtBQU9KIiwic291cmNlc0NvbnRlbnQiOlsiLmNhcmQge1xyXG4gICAgbWFyZ2luLXRvcDogNTBweDtcclxufVxyXG5cclxuLmNhcmQtaW1nLXRvcCB7XHJcbiAgICBtYXJnaW46IDAgYXV0bztcclxuICAgIG1heC13aWR0aDogMTAwJTtcclxuICAgIG1hcmdpbi10b3A6IDIwcHg7XHJcbn1cclxuXHJcbi5mb3JtLXNpZ25pbiB7XHJcbiAgICB3aWR0aDogMzgwcHg7XHJcbiAgICBwYWRkaW5nOiAxNXB4O1xyXG4gICAgbWFyZ2luOiAwIGF1dG87XHJcbn1cclxuLmZvcm0tc2lnbmluIC5mb3JtLXNpZ25pbi1oZWFkaW5nLFxyXG4uZm9ybS1zaWduaW4gLmNoZWNrYm94IHtcclxuICAgIG1hcmdpbi1ib3R0b206IDEwcHg7XHJcbn1cclxuLmZvcm0tc2lnbmluIC5jaGVja2JveCB7XHJcbiAgICBmb250LXdlaWdodDogbm9ybWFsO1xyXG59XHJcbi5mb3JtLXNpZ25pbiAuZm9ybS1jb250cm9sIHtcclxuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcclxuICAgIGhlaWdodDogYXV0bztcclxuICAgIC13ZWJraXQtYm94LXNpemluZzogYm9yZGVyLWJveDtcclxuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XHJcbiAgICBwYWRkaW5nOiAxMHB4O1xyXG4gICAgZm9udC1zaXplOiAxNnB4O1xyXG59XHJcbi5mb3JtLXNpZ25pbiAuZm9ybS1jb250cm9sOmZvY3VzIHtcclxuICAgIHotaW5kZXg6IDI7XHJcbn1cclxuLmZvcm0tc2lnbmluIGlucHV0W3R5cGU9J2VtYWlsJ10ge1xyXG4gICAgbWFyZ2luLWJvdHRvbTogLTFweDtcclxuICAgIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiAwO1xyXG4gICAgYm9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czogMDtcclxufVxyXG4uZm9ybS1zaWduaW4gaW5wdXRbdHlwZT0ncGFzc3dvcmQnXSB7XHJcbiAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xyXG4gICAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogMDtcclxuICAgIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiAwO1xyXG59XHJcbiJdLCJzb3VyY2VSb290IjoiIn0= */"]
});